import { Directive, ElementRef, AfterViewInit, OnDestroy, inject, output } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ScrollDirection } from '../../domain/direction';

@Directive({
  selector: '[tdWbHelpScroller]',
  exportAs: 'tdWbHelpScroller'

})
export class HelpScrollerDirective implements AfterViewInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);

  private static readonly ARTICLE_VISIBILITY_TOLERANCE: number = 150;
  private static readonly DEBOUNCE_DELAY: number = 100;

  readonly loadMore = output<ScrollDirection>();
  lastScrollTop: number = 0;
  nativeElement: HTMLElement;

  private scrollSubscription: Subscription;

  constructor() {
    this.nativeElement  = this.elementRef.nativeElement;
  }

  ngOnDestroy(): void {
    if (this.scrollSubscription !== undefined) {
      this.scrollSubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    this.scrollSubscription = fromEvent(this.nativeElement, 'scroll')
      .pipe(
        debounceTime(HelpScrollerDirective.DEBOUNCE_DELAY)
      )
      .subscribe((): void => {
        this.onScroll();
      });
  }

  private onScroll(): void {
    const currentScrollTop = this.nativeElement.scrollTop;
    if (currentScrollTop > this.lastScrollTop) {
      this.loadNext(currentScrollTop);
    } else {
      this.loadPrevious(currentScrollTop);
    }
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  private loadNext(currentScrollTop: number): void {
    if (currentScrollTop + this.nativeElement.clientHeight >
      this.nativeElement.scrollHeight - HelpScrollerDirective.ARTICLE_VISIBILITY_TOLERANCE) {
      this.loadMore.emit(ScrollDirection.DOWN);
    }
  }

  private loadPrevious(currentScrollTop: number): void {
    if (currentScrollTop < HelpScrollerDirective.ARTICLE_VISIBILITY_TOLERANCE) {
      this.loadMore.emit(ScrollDirection.UP);
    }
  }
}
